import { Account, Service } from '@acies/domain';
import { FeatureFlagsJSONSchema, IFeatureFlagsJSON, IFlagJSON } from '@acies/schema';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { handleDomainError } from '@shared/errors/domain-errors';
import { SessionStorageService } from '@shared/services/storage.service';
import { catchError, retry } from 'rxjs';
import { parse, transformFeatureFlags } from './adapters';

export class FlagsService {
	#baseURL: string;
	#headers: HttpHeaders;
	#httpClient: HttpClient;
	#sessionStorageService: SessionStorageService;
	public constructor(httpClient: HttpClient, sessionStorageService: SessionStorageService) {
		this.#httpClient = httpClient;
		this.#sessionStorageService = sessionStorageService;
		this.#baseURL = `${environment.awsEnvUri}/iam/featureflags`;
	}

	public loadFlags(accounts: Map<string, Account>) {
		return this.#httpClient
			.get<Service[]>(`${this.#baseURL}`, {
				headers: this.headers,
			})
			.pipe(retry(1), parse(FeatureFlagsJSONSchema), transformFeatureFlags(accounts), catchError(handleDomainError));
	}

	public updateFlags(body: IFlagJSON[]) {
		return this.#httpClient
			.put<IFeatureFlagsJSON>(`${this.#baseURL}`, body, {
				headers: this.headers,
			})
			.pipe(retry(1), parse(FeatureFlagsJSONSchema), catchError(handleDomainError));
	}

	private get headers(): HttpHeaders {
		if (!this.#headers) {
			this.#headers = new HttpHeaders({
				Authorization: `Bearer ${this.#sessionStorageService.get('User.Authorization')}`,
			});
		}
		return this.#headers;
	}
}
